import { render, staticRenderFns } from "./QuestionsListModalWrapper.form.vue?vue&type=template&id=2abf55eb&scoped=true&"
import script from "./QuestionsListModalWrapper.form.vue?vue&type=script&lang=js&"
export * from "./QuestionsListModalWrapper.form.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsListModalWrapper.form.vue?vue&type=style&index=0&id=2abf55eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abf55eb",
  null
  
)

export default component.exports